import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { insights } from '../data/site';
export function ThoughtLeadership() {
  return <>
      <PageHeader eyebrow="Thought Leadership" title="Perspectives for boards, founders, and investors." description="Writing and speaking on clinical governance, enterprise adoption, and underwriting risk in digital health." data-id="element-188" data-mp="1uo1z5649lsu5" />

      <section className="w-full bg-ivory py-20 lg:py-24" data-id="element-189" data-mp="1lu6sturepwcx">
        <div className="mx-auto grid max-w-7xl gap-8 px-6 md:grid-cols-3 lg:px-10" data-id="element-190" data-mp="1gvlrtt4bz8nf">
          {insights.map((item, i) => <motion.article key={item.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-70px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.09
        }} className="group flex flex-col justify-between border border-stone bg-white p-8 transition-transform duration-300 hover:-translate-y-1 lg:p-9" data-id="element-191" data-mp="1byn1zmrp9nv1" data-mpi={i}>
              <div data-id="element-192" data-mp="1t2anc07j470k">
                <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-brass-500" data-id="element-193" data-mp="1t2sonb91tbfc">
                  {item.kind}
                </span>
                <h2 className="mt-4 font-display text-lg leading-snug text-ink-950" data-id="element-194" data-mp="1xzasm8wk15qm">
                  {item.title}
                </h2>
                <p className="mt-3 text-[15px] leading-relaxed text-graphite" data-id="element-195" data-mp="2qqkpcf7beuro">
                  {item.body}
                </p>
              </div>
              <Link to="/contact" className="mt-8 inline-flex items-center gap-2 font-display text-[13px] text-ink-950 transition-colors hover:text-brass-500" data-id="element-196" data-mp="2cq065hxhmwxn">
                Request this discussion
                <ArrowUpRightIcon size={15} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-197" data-mp="15cg7d9rwy2c3" />
              </Link>
            </motion.article>)}
        </div>
      </section>
    </>;
}